import React from 'react';
import { object, mixed } from 'yup';
import PropTypes from 'prop-types';
import { Card, CardFooter, CardBody } from 'reactstrap';
import { Button, Form as BaseForm } from '@cordata/buffet';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  usePatient,
  formikValidate as validate,
} from '~/utils';
import { store } from '~/utils/care-team';
import Fields from './Fields';

const validationSchema = object().shape({
  provider: mixed().nullable().required(),
  patient: mixed().required(),
});

const Form = ({ data, disabled, isAdd }) => {
  const history = useHistory();
  const [, patient] = usePatient();

  return (
    <BaseForm
      enableReinitialize
      displayName="CareTeamForm"

      initialValues={{
        provider: '',
        careTeam: true,
        ...data,
        patient,
        isAdd,
      }}

      onSubmit={(values, actions) => {
        return validate(values, validationSchema)
          .then((validatedPayload) => {
            const { id, ...v } = validatedPayload;
            const method = id ? store.put : store.post;
            return method({ values: v, id })
              .then(() => toast.success('Successfully Saved!'))
              .then(() => history.push(`/patients/${values.patient.id}/care-team`))
              .catch((e) => actions.setErrors({ server: e.errors }));
          })
          .catch(e => {
            actions.setErrors(e);
            actions.setTouched(e); // needed for validation errors to show
          })
          .finally(() => actions.setSubmitting(false));
      }}
    >
      {({
        isSubmitting,
      }) => (
        <Card>
          <CardBody className="p-0">
            <Fields disabled={disabled} isAdd={isAdd} />
          </CardBody>

          <CardFooter className="d-flex">
            <div className="ml-auto">
              <Button
                type="button"
                color="tertiary"
                outline
                icon="times"
                disabled={isSubmitting}
                onClick={() => history.goBack()}
              >
                Cancel
              </Button>

              <Button type="submit" disabled={disabled || isSubmitting}>
                {isSubmitting ? 'Working ...' : 'Save'}
              </Button>
            </div>
          </CardFooter>
        </Card>
      )}
    </BaseForm>
  );
};

Form.propTypes = {
  data: PropTypes.shape(),
  disabled: PropTypes.bool,
  isAdd: PropTypes.bool,
};

Form.defaultProps = {
  data: {},
  disabled: false,
  isAdd: false,
};

export default Form;
